import { render } from "./CreateChapter.vue?vue&type=template&id=01c4fe20&scoped=true"
import script from "./CreateChapter.vue?vue&type=script&lang=js"
export * from "./CreateChapter.vue?vue&type=script&lang=js"

import "./CreateChapter.vue?vue&type=style&index=0&id=01c4fe20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c4fe20"]])

export default __exports__